import React from 'react'

const BarangayGoalsObjectives = ({ barangay }) => {
  if (!barangay.goals && !barangay.objectives) return null

  const hasGoals = barangay.goals && barangay.goals.trim()
  const hasObjectives = barangay.objectives && barangay.objectives.trim()
  const columnClass = (hasGoals && hasObjectives) ? 'col-lg-6' : 'col-lg-8'

  // Helper function to parse text into list items
  const parseListItems = (text) => {
    if (!text) return []
    // Split by newlines, numbers with dots, or bullets
    const items = text.split(/\n|(?=\d+\.)|(?=•)/).filter(item => item.trim())
    return items.length > 1 ? items : []
  }

  const goals = parseListItems(barangay.goals)
  const objectives = parseListItems(barangay.objectives)

  return (
    <section className="section bg-white">
      <div className="container">
        <div className="section-head text-center mb-5">
          <h2 className="title title-s4">Goals & Objectives</h2>
        </div>
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="row gutter-vr-40px justify-content-center">
              {hasGoals && (
                <div className={columnClass}>
                  <div className="content-box">
                    <h3 className="title title-sm mb-4">
                      <em className="fas fa-flag-checkered me-2" style={{ color: '#e02f29' }}></em>
                      Goals
                    </h3>
                    {goals.length > 0 ? (
                      <ul className="list list-check">
                        {goals.map((goal, index) => (
                          <li key={index} style={{ marginBottom: '10px' }}>{goal.trim()}</li>
                        ))}
                      </ul>
                    ) : (
                      <p style={{ lineHeight: '1.7', textAlign: 'justify' }}>{barangay.goals}</p>
                    )}
                  </div>
                </div>
              )}
              {hasObjectives && (
                <div className={columnClass}>
                  <div className="content-box">
                    <h3 className="title title-sm mb-4">
                      <em className="fas fa-tasks me-2" style={{ color: '#e02f29' }}></em>
                      Objectives
                    </h3>
                    {objectives.length > 0 ? (
                      <ul className="list list-check">
                        {objectives.map((objective, index) => (
                          <li key={index} style={{ marginBottom: '10px' }}>{objective.trim()}</li>
                        ))}
                      </ul>
                    ) : (
                      <p style={{ lineHeight: '1.7', textAlign: 'justify' }}>{barangay.objectives}</p>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default BarangayGoalsObjectives
